var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSup1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 788.046,
    height: 420.109,
    viewBox: "0 0 788.046 420.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0f0f0;}.b{fill:#fff;}.c{fill:#a0616a;}.d{fill:#2f2e41;}.e{fill:#44bba4;}.f{fill:#e5e5e5;}.g{fill:#e6e6e6;}.h{fill:#cacaca;}.i{fill:#3f3d56;}.j{fill:#e4e4e4;}.k{fill:#ffb8b8;}.l{fill:#ffb7b7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-976.384 -687.88)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M405.689,243.6c14.478-6.132,32.627-5.457,44.472,4.882a72.442,72.442,0,0,0-43.053,24.9c-4.209,5.076-8.363,11.16-14.836,12.418-4.028.783-8.235-.565-11.674-2.8s-6.237-5.312-9-8.35l-.96-.356C379.9,261.588,391.211,249.735,405.689,243.6Z",
    transform: "translate(791.879 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M449.98,248.761a61.918,61.918,0,0,0-37.872,4.121,26.664,26.664,0,0,0-7.075,4.442,15.293,15.293,0,0,0-4.236,6.844c-.772,2.427-1.281,5-2.63,7.2a9.364,9.364,0,0,1-6.388,4.223c-3.231.618-6.491.037-9.66-.641-3.518-.753-7.16-1.591-10.736-.708-.433.107-.574-.572-.141-.678,6.222-1.536,12.239,1.885,18.465,1.577,2.9-.144,5.784-1.164,7.524-3.611,1.521-2.139,2.048-4.791,2.809-7.255a16.319,16.319,0,0,1,3.893-6.846,24.65,24.65,0,0,1,6.879-4.7,60.071,60.071,0,0,1,18-5.341,63.016,63.016,0,0,1,21.392.718c.436.09.212.747-.22.657Z",
    transform: "translate(791.844 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M415.831,250.944a9.29,9.29,0,0,1,4.884-10.993c.4-.192.72.424.317.617a8.6,8.6,0,0,0-4.522,10.235c.128.427-.551.566-.678.141Z",
    transform: "translate(789.519 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M401.026,262.886a17.9,17.9,0,0,0,12.93,1.759c.434-.105.574.573.141.678a18.624,18.624,0,0,1-13.451-1.858C400.257,263.247,400.638,262.669,401.026,262.886Z",
    transform: "translate(790.792 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M435.681,247.289a5.258,5.258,0,0,0,2.714,4.187c.392.213.01.792-.38.58A5.893,5.893,0,0,1,435,247.43a.358.358,0,0,1,.269-.41A.348.348,0,0,1,435.681,247.289Z",
    transform: "translate(787.603 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M448.744,301.7c-.249-.126-.5-.253-.751-.376a69.256,69.256,0,0,0-10.417-4.2c-.275-.091-.556-.179-.833-.261A73.005,73.005,0,0,0,410.016,294a70.9,70.9,0,0,0-10.642,1.668c-4.833,1.14-9.984,2.761-14.77,2.252a12.157,12.157,0,0,1-1.487-.235L370.283,275.5c0-.065-.013-.127-.017-.193l-.553-.863c.178-.055.363-.109.54-.164.1-.032.209-.06.311-.092.069-.02.139-.04.2-.062l.064-.017c.062-.022.121-.036.178-.055q1.553-.452,3.117-.884c.005,0,.005,0,.013,0a104.244,104.244,0,0,1,24.329-3.936c.246-.007.5-.017.749-.014a67.651,67.651,0,0,1,11.021.646,59.8,59.8,0,0,1,5.938,1.167,49.734,49.734,0,0,1,14.3,6.106c8.8,5.529,15.744,13.812,18.1,23.8C448.632,301.192,448.689,301.443,448.744,301.7Z",
    transform: "translate(791.997 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M448.434,301.815a61.918,61.918,0,0,0-32.72-19.511,26.664,26.664,0,0,0-8.324-.713,15.293,15.293,0,0,0-7.5,2.914c-2.078,1.473-4.033,3.22-6.432,4.162a9.364,9.364,0,0,1-7.643-.474c-2.952-1.452-5.206-3.878-7.327-6.328-2.356-2.719-4.759-5.581-8.146-7.029-.41-.175-.114-.8.3-.627,5.893,2.519,8.637,8.874,13.794,12.376,2.406,1.634,5.319,2.553,8.181,1.647,2.5-.792,4.52-2.592,6.611-4.1a16.319,16.319,0,0,1,7.23-3.122,24.649,24.649,0,0,1,8.321.39,60.071,60.071,0,0,1,17.587,6.572,63.016,63.016,0,0,1,16.648,13.453c.293.334-.28.724-.572.392Z",
    transform: "translate(791.953 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M419.854,283a9.29,9.29,0,0,1,10.518-5.837c.437.089.319.772-.118.683a8.6,8.6,0,0,0-9.773,5.45c-.155.418-.781.12-.627-.3Z",
    transform: "translate(788.906 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.842,283.619a17.905,17.905,0,0,0,9.265,9.189c.41.177.114.8-.3.627a18.624,18.624,0,0,1-9.621-9.582c-.18-.409.474-.641.652-.234Z",
    transform: "translate(790.941 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M437.9,292.03a5.259,5.259,0,0,0-.354,4.977c.185.407-.469.638-.652.234a5.892,5.892,0,0,1,.38-5.507.358.358,0,0,1,.461-.166.348.348,0,0,1,.166.461Z",
    transform: "translate(787.53 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M851.45,409.1H840.089l-5.4-43.824h16.768Z",
    transform: "translate(820 685.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M955.848,659.8H919.213v-.463a14.26,14.26,0,0,1,14.258-14.259h22.377Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M939.916,404.178l-11.234,1.7-11.9-42.523,14.727-2.506Z",
    transform: "translate(820 685.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1045.93,654.325l-36.223,5.475-.069-.458a14.26,14.26,0,0,1,11.968-16.23h0l22.124-3.344Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M717.34,659.8H377.849V320.309H717.34Z",
    transform: "translate(779.061 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M717.34,659.8H377.849V320.309H717.34Zm-334.475-5.016H712.324V325.325H382.865Z",
    transform: "translate(779.061 448.189)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 914.441)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 934.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 954.408)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "translate(1217.546 914.395)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 828.334)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 848.318)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 868.303)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "translate(1217.546 827.451)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 1001.387)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 1021.369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 217.726,
    height: 7.686,
    transform: "translate(1224.469 1041.352)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "translate(1217.546 1000.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M899.578,525.691H702.044c-2.959-.008-5.358-4.913-5.362-10.97V367.766c0-6.056,2.4-10.96,5.362-10.97H899.578c2.959.008,5.358,4.913,5.362,10.97V514.719C904.936,520.775,902.533,525.683,899.578,525.691Z",
    transform: "translate(745.305 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M899.578,525.691H702.044c-2.959-.008-5.358-4.913-5.362-10.97V367.766c0-6.056,2.4-10.96,5.362-10.97H899.578c2.959.008,5.358,4.913,5.362,10.97V514.719C904.936,520.775,902.533,525.683,899.578,525.691ZM702.044,361.184c-1.776,0-3.215,2.949-3.218,6.582V514.719c0,3.633,1.441,6.579,3.218,6.582H899.578c1.776,0,3.215-2.948,3.218-6.582V367.766c0-3.633-1.441-6.579-3.218-6.582Z",
    transform: "translate(745.305 448.189)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 53.171,
    height: 3.996,
    transform: "translate(1523.897 924.809)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 66.916,
    height: 3.996,
    transform: "translate(1516.491 935.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M835.529,426.2a34.731,34.731,0,0,1-51.18,30.575l-.007-.007a34.72,34.72,0,1,1,51.187-30.569Z",
    transform: "translate(749.153 448.189)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 9.438,
    cy: 9.438,
    r: 9.438,
    transform: "translate(1541.814 853.834)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M817.1,444.021a48.645,48.645,0,0,1-32.577-.126l-.007,0,7.031-13.879h18.876Z",
    transform: "translate(749.988 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M560.144,338.547H708.36V273.559h-2.281v62.707H560.144Z",
    transform: "translate(856.363 687.881)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 12.541,
    cy: 12.541,
    r: 12.541,
    transform: "translate(1545.507 959.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M387.578,435.691H190.044c-2.959-.008-5.358-4.913-5.362-10.97V277.766c0-6.056,2.4-10.96,5.362-10.97H387.578c2.959.008,5.358,4.913,5.362,10.97V424.719C392.936,430.775,390.533,435.683,387.578,435.691Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M387.578,435.691H190.044c-2.959-.008-5.358-4.913-5.362-10.97V277.766c0-6.056,2.4-10.96,5.362-10.97H387.578c2.959.008,5.358,4.913,5.362,10.97V424.719C392.936,430.775,390.533,435.683,387.578,435.691ZM190.044,271.184c-1.776,0-3.215,2.949-3.218,6.582V424.719c0,3.633,1.441,6.579,3.218,6.582H387.578c1.776,0,3.215-2.948,3.218-6.582V277.766c0-3.633-1.441-6.579-3.218-6.582Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M332.664,312.7a48.949,48.949,0,0,0-33.7-15.35v49.051Z",
    transform: "translate(800.802 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M332.664,318.813l-33.7,33.7h47.1a48.923,48.923,0,0,0-13.4-33.7Z",
    transform: "translate(800.51 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M346.111,356.038a49.226,49.226,0,0,1-.845,9.113c-.044.238-.09.474-.138.709a48.7,48.7,0,0,1-5.682,14.889c-.143.248-.291.5-.44.738v0a49.246,49.246,0,0,1-9.858,11.663c-.192.168-.384.333-.578.5a48.88,48.88,0,0,1-29.608,11.441V356.038Z",
    transform: "translate(800.509 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M294.2,405.131c.652,0,1.3-.017,1.946-.042V356.037L260.471,391.71A48.923,48.923,0,0,0,294.2,405.131Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M294.265,303.419a49.094,49.094,0,0,0-49.094,49.094h51.091v-49.05C295.6,303.437,294.934,303.419,294.265,303.419Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M282.552,356.038,272.23,366.36l-.338.338-.007.007-9,9-.342.342-9.725,9.725-.342.342v0l-5.6,5.594a48.953,48.953,0,0,1-15.368-35.671Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M346.913,250.547H198.7V185.559h2.28v62.707H346.913Z",
    transform: "translate(899.362 687.881)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 12.541,
    cy: 12.541,
    r: 12.541,
    transform: "translate(1110.297 871.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1006.39,431.608l-12.615,3.305.839,20.453.1,37.238a7.463,7.463,0,1,0,9.877,1.241l3.877-37.374Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1009.91,443.906,991.471,437.7l-.043-.278c-.027-.175-2.732-17.639-2.7-29.62a9.18,9.18,0,0,1,3.06-7.1,9.628,9.628,0,0,1,10.422-1.676,10.3,10.3,0,0,1,6.366,9.158Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M975.611,442.192l-28.2-7.3L934.371,478.8l-.463,163.569,21.567-.135,9.015-132.389,57.458,122.329,23.168-2.78L994.609,498.26s2.78-23.168-6.024-34.753l1.853-12.048Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M991.274,454.7l-2.134-.033L945.8,437.346l20.735-46.181,9.844,1.789-1.792-7.169,21.752-5.317,3.785,15.138,5.585,5.076a9.819,9.819,0,0,1,2.708,10.363L995.55,449.639a4.337,4.337,0,0,1-4.276,5.064Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M958.679,420.123l-11.4-6.329-13.527,15.363-25.658,26.987a7.463,7.463,0,1,0,6.281,7.722L943,439.532Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M952.732,431.451l-9.037-17.23.161-.231c.1-.145,10.215-14.638,18.518-23.275a9.18,9.18,0,0,1,7.117-3.017,9.633,9.633,0,0,1,8.691,5.99,10.3,10.3,0,0,1-1.727,11.018Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 17.283,
    cy: 17.283,
    r: 17.283,
    transform: "translate(1681.46 789.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M959.446,350.235c2.906-5.2,4.018-7.376,7.766-10.54,3.314-2.8,7.39-3.62,10.677-.969a19.8,19.8,0,1,1-11.745,15.846C963.286,354.171,962.3,350.636,959.446,350.235Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M195.092,501.322a6.493,6.493,0,0,0,1.546-9.835l8.437-84.666-14.088.935-3.9,83.37a6.528,6.528,0,0,0,8.008,10.2Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M185.279,403.686l3.694,28.072-.513,17.205,15.495,1.419,3.105-14.31,1.711-37.884a11.305,11.305,0,0,0-9.988-11.74h0A11.305,11.305,0,0,0,186.27,396.2Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M143.119,411h9.4l4.471-36.254H143.117Z",
    transform: "translate(923 687.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.221,647.62h18.511a11.8,11.8,0,0,1,11.8,11.8v.384H242.222Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M65.508,411h9.4l4.471-36.254H65.506Z",
    transform: "translate(923 687.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M164.61,647.62h18.511a11.8,11.8,0,0,1,11.8,11.8v.384H164.611Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 20.378,
    cy: 20.378,
    r: 20.378,
    transform: "translate(1004.68 780.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M206.191,381.378l-14.142,1.616h0a37.633,37.633,0,0,0-4.812,33.982l10.671,30.87s-14.813,29.7-14.813,57.268S154.884,631.1,154.884,631.1l39.709,4.142L211.919,530.4,235.8,634.822l27.258-4.437-15.013-136.9-9.92-45.061-.423-21.975s4.218-16.489-6.339-27.046l-12.889-17.96Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M305.888,453.971a7.114,7.114,0,0,0-8.635-6.665l-76.9-52.7-6.522,14.028L291.875,456.3a7.152,7.152,0,0,0,14.013-2.324Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M206.912,411.977l28.917,11.236,16.26,9.554,9.524-14.14L249.5,408.107l-35.5-21.6a12.387,12.387,0,0,0-16.54,3.414h0a12.387,12.387,0,0,0,2.775,17.156Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M227.313,345.449H197.367V332.4c6.573-2.611,13-4.832,16.892,0a13.053,13.053,0,0,1,13.053,13.053Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M202.709,331.092c-17.9.079-22.913,22.439-22.913,35.1,0,7.06,3.193,9.585,8.21,10.439l1.772-9.45,4.15,9.856c1.409.007,2.89-.02,4.425-.049l1.407-2.9,3.138,2.845c12.567.019,30.829-1.1,22.724-10.745C214.764,353.274,218.313,331.023,202.709,331.092Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1023.28,401.362a20.993,20.993,0,0,1-.346-9.178c.835-5.886,2.714-11.563,4.432-17.254s3.293-11.494,3.492-17.435-1.09-12.1-4.632-16.874-9.583-7.9-15.459-7c-5.615.858-10.518,5.922-10.547,11.541-1.005,1.819.293,4.3,2.142,5.381,1.939,1.131,4.277,1.282,6.428,1.925a16.115,16.115,0,0,1,9.657,8.547,20.834,20.834,0,0,1,1.4,12.977c-.847,4.229-2.8,8.142-4.256,12.2s-2.437,8.513-1.264,12.663a13.336,13.336,0,0,0,14.946,9.107,9.846,9.846,0,0,1-5.992-6.6Z",
    transform: "translate(718.5 446.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M870.464,611.694c-1.94-15.6-11.61-30.976-26.49-36.054a72.442,72.442,0,0,1,0,49.736c-2.287,6.185-5.474,12.826-3.323,19.06,1.338,3.879,4.612,6.846,8.271,8.7s7.721,2.74,11.732,3.607l.789.653C867.806,643.021,872.4,627.3,870.464,611.694Z",
    transform: "translate(744.314 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M843.826,575.935a61.918,61.918,0,0,1,15.393,34.847,26.665,26.665,0,0,1-.3,8.349,15.293,15.293,0,0,1-3.8,7.093c-1.714,1.884-3.686,3.612-4.913,5.879a9.364,9.364,0,0,0-.457,7.644c1.083,3.106,3.218,5.638,5.391,8.041,2.413,2.668,4.962,5.4,5.988,8.94.124.429.782.211.658-.217-1.785-6.155-7.76-9.651-10.609-15.195-1.33-2.587-1.888-5.59-.641-8.321,1.09-2.388,3.122-4.172,4.874-6.064a16.318,16.318,0,0,0,3.977-6.8,24.652,24.652,0,0,0,.623-8.306,60.07,60.07,0,0,0-4.387-18.255,63.015,63.015,0,0,0-11.331-18.159c-.3-.332-.753.19-.459.52Z",
    transform: "translate(744.941 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M859.032,606.589a9.29,9.29,0,0,0,7.071-9.731c-.035-.444-.728-.41-.692.035a8.6,8.6,0,0,1-6.6,9.039c-.434.1-.214.76.217.658Z",
    transform: "translate(744.239 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M856.107,625.384a17.905,17.905,0,0,1-8-10.312c-.126-.428-.784-.21-.658.217A18.625,18.625,0,0,0,855.8,626c.384.228.694-.392.312-.619Z",
    transform: "translate(745.277 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M852.259,587.576a5.258,5.258,0,0,1-4.983-.253c-.381-.233-.69.388-.312.619a5.892,5.892,0,0,0,5.512.292.358.358,0,0,0,.22-.438.348.348,0,0,0-.438-.22Z",
    transform: "translate(745.567 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M798.616,603.509c.234.152.468.3.7.462a69.258,69.258,0,0,1,8.854,6.913c.216.193.433.392.643.591a73.006,73.006,0,0,1,15.855,21.7,70.9,70.9,0,0,1,3.883,10.048c1.433,4.755,2.608,10.024,5.445,13.914a12.166,12.166,0,0,0,.948,1.17h25.634c.058-.029.117-.053.175-.082l1.023.047c-.041-.181-.088-.368-.129-.55-.023-.105-.053-.211-.076-.316-.017-.07-.035-.14-.047-.2-.006-.023-.012-.047-.017-.064-.012-.064-.029-.123-.041-.181q-.386-1.57-.8-3.141c0-.006,0-.006-.006-.012a104.248,104.248,0,0,0-8.773-23.031c-.117-.216-.234-.439-.363-.655a67.658,67.658,0,0,0-6.077-9.217,59.814,59.814,0,0,0-3.983-4.556,49.733,49.733,0,0,0-12.446-9.323c-9.194-4.854-19.838-6.714-29.664-3.749C799.113,603.351,798.867,603.427,798.616,603.509Z",
    transform: "translate(746.122 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M798.674,603.834a61.919,61.919,0,0,1,33.271,18.556,26.662,26.662,0,0,1,4.784,6.849,15.3,15.3,0,0,1,1.234,7.953c-.235,2.536-.769,5.1-.383,7.652a9.364,9.364,0,0,0,4.237,6.379c2.735,1.828,5.963,2.565,9.146,3.175,3.533.678,7.214,1.326,10.163,3.533.357.267.751-.3.395-.57-5.131-3.84-12.006-3.034-17.619-5.745-2.619-1.265-4.873-3.327-5.522-6.258-.567-2.563-.019-5.21.241-7.776a16.318,16.318,0,0,0-.916-7.822,24.65,24.65,0,0,0-4.5-7.007,60.074,60.074,0,0,0-14.494-11.934,63.016,63.016,0,0,0-19.98-7.677c-.436-.087-.487.605-.053.691Z",
    transform: "translate(746.138 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M829.271,619.154a9.29,9.29,0,0,0-.213-12.027c-.3-.334-.828.11-.532.444a8.6,8.6,0,0,1,.175,11.188C828.417,619.1,828.988,619.5,829.271,619.154Z",
    transform: "translate(747.659 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M838.251,635.922a17.905,17.905,0,0,1-12.593-3.42c-.358-.266-.752.3-.395.57a18.624,18.624,0,0,0,13.111,3.532C838.819,636.554,838.693,635.873,838.251,635.922Z",
    transform: "translate(747.205 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M812.415,608.051a5.258,5.258,0,0,1-4.131,2.8c-.444.044-.318.725.124.682a5.892,5.892,0,0,0,4.577-3.085.358.358,0,0,0-.088-.482.348.348,0,0,0-.482.088Z",
    transform: "translate(749.583 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M293.594,611.694c1.94-15.6,11.61-30.976,26.49-36.054a72.442,72.442,0,0,0,0,49.736c2.287,6.185,5.474,12.826,3.323,19.06-1.338,3.879-4.612,6.846-8.271,8.7s-7.721,2.74-11.732,3.607l-.789.653C296.252,643.021,291.653,627.3,293.594,611.694Z",
    transform: "translate(801.468 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M320.232,575.935a61.918,61.918,0,0,0-15.393,34.848,26.663,26.663,0,0,0,.3,8.349,15.293,15.293,0,0,0,3.8,7.093c1.714,1.884,3.686,3.612,4.913,5.879a9.364,9.364,0,0,1,.457,7.644c-1.083,3.106-3.217,5.638-5.391,8.041-2.413,2.668-4.962,5.4-5.988,8.94-.124.429-.782.211-.658-.217,1.785-6.155,7.76-9.651,10.609-15.195,1.33-2.587,1.888-5.59.641-8.321-1.09-2.388-3.122-4.172-4.874-6.064a16.318,16.318,0,0,1-3.977-6.8,24.649,24.649,0,0,1-.623-8.306,60.071,60.071,0,0,1,4.387-18.255,63.016,63.016,0,0,1,11.331-18.159c.3-.332.753.19.459.52Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M305.026,606.589a9.29,9.29,0,0,1-7.071-9.731c.035-.444.728-.41.692.035a8.6,8.6,0,0,0,6.6,9.039C305.677,606.034,305.457,606.692,305.026,606.589Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M307.951,625.384a17.905,17.905,0,0,0,8-10.312c.126-.428.784-.21.658.217A18.624,18.624,0,0,1,308.263,626c-.384.228-.694-.392-.312-.619Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M311.8,587.576a5.258,5.258,0,0,0,4.983-.253c.381-.233.69.388.312.619a5.892,5.892,0,0,1-5.512.292.358.358,0,0,1-.22-.438.348.348,0,0,1,.438-.22Z",
    transform: "translate(821.5 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M365.441,603.509c-.234.152-.468.3-.7.462a69.252,69.252,0,0,0-8.854,6.913c-.216.193-.433.392-.643.591a73.006,73.006,0,0,0-15.855,21.7,70.89,70.89,0,0,0-3.884,10.048c-1.433,4.755-2.608,10.024-5.445,13.914a12.162,12.162,0,0,1-.948,1.17H303.476c-.058-.029-.117-.053-.175-.082l-1.023.047c.041-.181.088-.368.129-.55.023-.105.053-.211.076-.316.017-.07.035-.14.047-.2.006-.023.012-.047.017-.064.012-.064.029-.123.041-.181q.386-1.57.8-3.141c0-.006,0-.006.006-.012a104.246,104.246,0,0,1,8.773-23.032c.117-.216.234-.439.363-.655A67.648,67.648,0,0,1,318.6,620.9a59.82,59.82,0,0,1,3.983-4.556,49.735,49.735,0,0,1,12.445-9.323c9.194-4.854,19.838-6.714,29.664-3.749C364.944,603.351,365.19,603.427,365.441,603.509Z",
    transform: "translate(799.79 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M365.384,603.834a61.917,61.917,0,0,0-33.271,18.556,26.665,26.665,0,0,0-4.784,6.849,15.293,15.293,0,0,0-1.234,7.953c.235,2.536.769,5.1.383,7.652a9.364,9.364,0,0,1-4.237,6.379c-2.735,1.828-5.963,2.565-9.146,3.175-3.533.678-7.214,1.326-10.163,3.533-.357.267-.751-.3-.395-.57,5.131-3.84,12.006-3.034,17.619-5.745,2.619-1.265,4.873-3.327,5.522-6.258.567-2.563.019-5.21-.241-7.776a16.318,16.318,0,0,1,.916-7.822,24.652,24.652,0,0,1,4.5-7.007,60.071,60.071,0,0,1,14.494-11.934,63.016,63.016,0,0,1,19.98-7.677c.436-.086.487.605.053.691Z",
    transform: "translate(799.774 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M334.787,619.154A9.29,9.29,0,0,1,335,607.127c.3-.334.828.11.532.444a8.6,8.6,0,0,0-.175,11.188C335.641,619.1,335.07,619.5,334.787,619.154Z",
    transform: "translate(798.017 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M325.806,635.922A17.905,17.905,0,0,0,338.4,632.5c.358-.266.752.3.395.57a18.624,18.624,0,0,1-13.111,3.532c-.444-.049-.318-.731.124-.682Z",
    transform: "translate(798.511 448.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M351.642,608.051a5.258,5.258,0,0,0,4.131,2.8c.444.044.318.725-.124.682a5.892,5.892,0,0,1-4.577-3.086.358.358,0,0,1,.087-.482.348.348,0,0,1,.482.088Z",
    transform: "translate(796.101 448.189)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSup1);
export default __webpack_public_path__ + "static/media/sup1.6158f3a491e6e11166bf8c9cd7a8cd53.svg";
export { ForwardRef as ReactComponent };